var map = {
	"./01img.png": "jFnN",
	"./02img.png": "KFlk",
	"./03img.png": "dMXD",
	"./04img.png": "XLZD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AfHp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/01challengeList ^\.\/0.*img\.png$
// module id = AfHp
// module chunks = 0